import { createAsyncThunk } from '@reduxjs/toolkit';

import { IMetaTag } from '.';
import { ApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';

export interface IGetMetaTagByPath {
  path: string;
}

const MetaTagApiDataProvider = new APIDataProvider<IMetaTag>();

export const getMetaTags = createAsyncThunk(
  'meta_tag/get',
  async (data: IGetMetaTagByPath) => {
    const response = await MetaTagApiDataProvider.getById(
      `${ApiPaths.meta_tag}?path=${data.path}`
    );
    return response.data as IMetaTag;
  }
);
